export default __webpack_public_path__ + "static/media/BLACK_BLUE_BLACK.72d2eb41.jpg";